module.exports = __webpack_public_path__ + "static/freeWheel-white-a07dc083c6db1fd1b5923d142d7f9d11.png";